import { events } from "@/constants";
import { on, emit } from "@/neon/events";

const selectors = {
  innerOverlay: ".drawer-overlay__inner",
};

const classes = {
  isVisible: "is-visible",
  isActive: "is-active",
};

const drawerOverlay = node => {
  if (!node) return;
  const overlay = node;
  const overlayInner = node.querySelector(selectors.innerOverlay);

  const overlayShowListener = on(events.drawerOverlay.show, () =>
    _showOverlay()
  );
  const overlayHideListener = on(events.drawerOverlay.hide, () =>
    _hideOverlay()
  );

  const _showOverlay = () => {
    overlay.classList.add(classes.isActive);

    setTimeout(() => {
      overlayInner.classList.add(classes.isVisible);
    }, 10);
  };

  const _hideOverlay = () => {
    emit(events.drawerOverlay.hiding);
    overlayInner.classList.remove(classes.isVisible);

    setTimeout(() => {
      overlay.classList.remove(classes.isActive);
    }, 300);
  };

  overlay.addEventListener("click", _hideOverlay);

  const unload = () => {
    overlayShowListener();
    overlayHideListener();

    overlay.removeEventListener("click", _hideOverlay);
  };

  return { unload };
};

export default drawerOverlay;
